// var ScrollMagic = require('ScrollMagic');
// import 'TweenLite.js';
// var TweenMax = require('../node_modules/gsap/src/minified/TweenMax.min.js');
// import '../node_modules/gsap/src/minified/TweenLite.min.js'
// import TweenMax from 'gsap';
// import TimelineMax from 'gsap';

//var TweenMax = require('gsap');
//import * as TweenMax from '../node_modules/gsap/src/minified/TweenMax.min.js'
// import '../node_modules/gsap/src/minified/TimelineMax.min.js'
// import '../node_modules/scrollmagic/scrollmagic/minified/plugins/debug.addIndicators.min.js'
// import '../node_modules/scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap.js'

//require('../node_modules/scrollmagic/scrollmagic/minified/plugins/animation.gsap.min.js');
// import '../node_modules/gsap/src/minified/TweenMax.min.js'
// console.log('ScrollMagic',ScrollMagic )

//console.log('tweenmax',TweenMax);
// init controller
var controller = new ScrollMagic.Controller();

$(function () {
	new ScrollMagic.Scene({triggerElement: "main", triggerHook: 'onLeave', offset:0})
		.setClassToggle("#search-app", "nav-dark") // add class toggle
		.addTo(controller)
	  .on('enter', function() {
	    $('#nav-main').addClass('nav-dark')
	  })
	   .on('leave', function() {
	    $('#nav-main').removeClass('nav-dark')
	  });

	// new ScrollMagic.Scene({triggerElement: ".share-block", triggerHook: 'onLeave'})
	// 		.setPin(".share-block")
	// 		.addTo(controller);


	// loop through all the hide-share elements (shared class)
	// for each you would get its height and set as duration
	// new ScrollMagic.Scene({triggerElement: ".hide-share-1", triggerHook: 'onLeave', duration: heightOfThing})
	// 		.setClassToggle(".share-block", "hidden") // add class toggle
	// 		.addTo(controller);





		var homepageSectionLength = $('.section-homepage').length;

		for (var i = 1; i <= homepageSectionLength; i++) {
			// new ScrollMagic.Scene({triggerElement: "#person" + i, triggerHook: 'onLeave', duration: '100%' })
			// 	.setPin("#person" + i)
			// 	.addTo(controller)

				 	//var tween = TweenMax.to("#info" + i, 1, {className: "+=fadeOut"});

				var tweenText = TweenMax.to(".fader"+ i, 1, {opacity: 0});
				var tweenPersonFadein = TweenMax.to("#person"+ i, 1,{opacity: 1});
				var tweenPersonFadeout = TweenMax.to("#person"+ i, 1,{opacity: 0});
				// var tweenOverlayFadeout = TweenMax.to("#backgroundOverlay", 1,{opacity: 0});
				// var tweenOverlayFadein = TweenMax.to("#backgroundOverlay", 1,{opacity: 1});


				new ScrollMagic.Scene({triggerElement: "#info-content" + i, triggerHook: 'onLeave', duration: '200', offset:'-200'})
					.setTween(tweenText)
					.addTo(controller)
					// .addIndicators({name: "fadeoutText"+i});

				// new ScrollMagic.Scene({triggerElement: "#info-content" + i, triggerHook: 'onLeave', duration: '100', offset:'0'})
				// 	.setTween(tweenOverlayFadeout)
				// 	.addTo(controller)
					// .addIndicators({name: "fadeout"+i});


				new ScrollMagic.Scene({triggerElement: "#info-content" + i, duration: '100%', triggerHook: 'onEnter'})
					.setClassToggle("#nav-menu li:nth-child("+i+")", "active")
					.addTo(controller)

				// new ScrollMagic.Scene({triggerElement: "#info-content" + i, triggerHook: '.7', duration: '200'})
				// 	.setTween(tweenOverlayFadein)
				// 	.addTo(controller)
					// .addIndicators({name: "fadein"+i});

				// if (i < homepageSectionLength){ // don't add fadeout to last person

				new ScrollMagic.Scene({triggerElement: "#info-content" + i, triggerHook: 'onLeave', duration: '100', offset:'0'})
					.setTween(tweenPersonFadeout)
					.addTo(controller)
					// .addIndicators({name: "personfadeout"+i});
				// }
				new ScrollMagic.Scene({triggerElement: "#info-content" + i, triggerHook: 'onEnter', duration: '200', offset:'100'})
					.setTween(tweenPersonFadein)
					.addTo(controller)
					// .addIndicators({name: "personfadein"+i});

		}


});



// WEBPACK FOOTER //
// ./scripts/scroll-magic.js